/**
 * @props isOpen: drawer state. (boolean)
 * @props onCloseCb: callback function to be called won attempting to close the drawer. This function should change the isOpen state to false.
 * @props children: (node)
 */

import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import HoverContainer from '../hovercontainer/HoverContainer';
import { VEC_ICON_NAME } from '../icons/constants';
import Icons from '../icons/Icons';
import styles from './Drawer.styles';

export default function Drawer({isOpen, onCloseCb, children, customStyles = {}, drawerBodyStyles = {}}) {

    const bodyRef = useRef(document.querySelector('body'));
	useEffect(() => {
        const updatePageScroll = () => {
        if (isOpen) {
            bodyRef.current.style.overflow = 'hidden';
        } else {
            bodyRef.current.style.overflow = '';
        }
        };
        updatePageScroll();
    }, [isOpen]);
    
    return createPortal(
        <>
            <div
                onClick={onCloseCb}
                style={{
                    ...styles.overlay,
                    visibility: isOpen ? "visible" : "hidden",
                    opacity: isOpen ? "1" : "0",
                }}
            ></div>
            <div style={{...styles.drawerContainer, ...customStyles, ...(isOpen ? styles.showDrawer : "")}}>
                <div style={styles.closeIcon}>
                    <HoverContainer onClick={onCloseCb}>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.CLOSE} />
                    </HoverContainer>
                </div>
                <div style={{...styles.drawerBody, ...drawerBodyStyles}}>
                    {children}
                </div>
            </div>
        </>,
        document.querySelector('#mainContainer')
    )
}